<info *ngIf="info" [imgSrc]="info.imgSrc" [title]="info.title" [subTitle]="info.subTitle" [hint]="info.hint"></info>
<form [formGroup]="formGroup" autocomplete="off">
  <ng-container *ngFor="let isfEntity of possibleIsfEntities">
    <entity-unify-card
      [isfEntity]="isfEntity"
      [formGroup]="formGroup"
      [code]="isfEntityCode"
      [tooltipData]="info?.tooltip"
      [index]="cardLabelIndex(isfEntity)"
    ></entity-unify-card>
  </ng-container>
  <entity-unify-update [isfEntity]="updateIsfEntity" [formGroup]="formGroup" [code]="isfEntityCode" [errors]="errors"></entity-unify-update>
</form>
<missing-fields [code]="'LABELS.ISF'" (confirm)="confirm()" (decline)="decline()"></missing-fields>
